<template>
  <div style="padding:20px;">
    <h1>Location Sales Comparison</h1>
    <!-- <p><strong>Note:</strong> This is a comparison of NON Fuel Customers (NFC) from 8am to 6pm</p> -->
    
    
    <h4>RCGB</h4>
    <p>Legend: Fo = Fuel Only, Fs = Fuel and Store, Nf = No Fuel (store only)</p>
    <p>Totals are without tax (except for fuel which is tax included)</p>
    <div style="width:300px">
      <BasicTableComponent :list="rcgbList" :formatters="listFormatters" :titles="listTitles"/>
    </div>
    
    <h4>RMGB</h4>
    <p>Legend: Fo = Fuel Only, Fs = Fuel and Store, Nf = No Fuel (store only)</p>
    <p>Totals are without tax (except for fuel which is tax included)</p>
    <div style="width:300px">        
      <BasicTableComponent :list="rmgbList" :formatters="listFormatters" :titles="listTitles"/>
    </div>
    
    <h4>WGB</h4>
    <p>Legend: Fo = Fuel Only, Fs = Fuel and Store, Nf = No Fuel (store only)</p>
    <p>Totals are without tax (except for fuel which is tax included)</p>
    <div style="width:300px">        
      <BasicTableComponent :list="wgbList" :formatters="listFormatters" :titles="listTitles"/>
    </div>
    
    <div id="chart" style="width:300px;height:300px;"></div>
  </div>
</template>

<script>

export default {
  name: 'LocationSalesComparison',
  data () { return { 
      rcgbList: [],
      rmgbList: [],
      wgbList: [],
      listFormatters: {
        'date' : ['d', 'ddd YYYY-MM-DD'],
        'nfc_total' : ['n', '0'],
        'fc_total' : ['n', '0'],
        
        'fo_total' : ['n', '0'],
        'fs_total' : ['n', '0'],
        'nf_total' : ['n', '0']
      },
      listTitles: {}
    } 
  },
  async created () {

    i_axios.post('/Reports/dailySales', {location:'RCGB'}).then((r)=>{
      this.rcgbList = r.data
    })
    i_axios.post('/Reports/dailySales', {location:'RMGB'}).then((r)=>{
      this.rmgbList = r.data
    })
    i_axios.post('/Reports/dailySales', {location:'WGB'}).then((r)=>{
      this.wgbList = r.data
    })
    
    // let r2 = await i_axios.post('/LiveData/latestSales', {location:'RMGB'})
    // console.log(r2.data)
    
    
  },
  mounted() {
    //this.createChart()
  },
  methods: {
    createChart: function(){
      let options = {
        chart: {
          type: 'line'
        },
        series: [{
          name: 'sales',
          data: [30,40,35,50,49,60,70,91,125]
        }],
        xaxis: {
          categories: [1991,1992,1993,1994,1995,1996,1997, 1998,1999]
        }
      }
      let chart
      this.$loadApex(()=> chart = new ApexCharts(document.querySelector("#chart"), options))
      chart.render();
    }
  },
}
</script>

<style>

</style>
